import { toRomeDatetimeLocal } from "../utils/datetime";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import React, { useState, useEffect } from "react";
import apiService from "../services/api.service";
import { useHistory, useParams } from "react-router-dom";
import FlashAlert from "../Components/FlashAlert/FlashAlert";
import "./login.css";

const ModifyEvent = () => {
  const [date, setDate] = useState("");
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [embedLink, setEmbedLink] = useState("");
  const [finished, setFinished] = useState(false);
  const [status, setStatus] = useState("inactive");
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [successfulRegister, setSuccessfulRegister] = useState(true);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const history = useHistory();
  const { id } = useParams();

  useEffect(() => {
    const load = async () => {
      try {
        const event = await apiService.getEvent(id);
        setName(event.data.name || "");
        setDescription(event.data.description || "");
        setDate(toRomeDatetimeLocal(event.data.date));
        setEmbedLink(event.data.embed_link || "");
        setFinished(Boolean(event.data.finished));
      } catch (error) {
        console.error(error);
      }
      try {
        const response = await apiService.getEventStatus(id);
        setStatus(response.data?.status || response.data || "inactive");
      } catch (error) {
        console.error(error);
      }
    };
    load();
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setButtonDisabled(true);
    try {
      await apiService.modifyEvent(date, name, description, embedLink, finished, id);
      await apiService.setEventStatus(id, status);
      history.push("/events", { successReason: "Evento modificato con successo" });
    } catch (error) {
      console.log(error);
      setFormSubmitted(true);
      setSuccessfulRegister(false);
      setButtonDisabled(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card login-card--wide">
        {formSubmitted && !successfulRegister && (
          <FlashAlert variant="danger">Errore durante la modifica.</FlashAlert>
        )}
        <h1 className="login-title">Modifica evento</h1>
        <Form onSubmit={handleSubmit} className="login-form">
          <Form.Group className="mb-3" controlId="formBasicName">
            <Form.Label>Nome evento</Form.Label>
            <Form.Control required type="text" value={name} onChange={(e) => setName(e.target.value)} />
          </Form.Group>
          <Form.Group className="mb-3" controlId="formBasicDescription">
            <Form.Label>Descrizione</Form.Label>
            <Form.Control required type="text" value={description} onChange={(e) => setDescription(e.target.value)} />
          </Form.Group>
          <Form.Group className="mb-3" controlId="eventDate">
            <Form.Label>Data e ora (Roma)</Form.Label>
            <Form.Control required type="datetime-local" value={date} onChange={(e) => setDate(e.target.value)} />
          </Form.Group>
          <Form.Group className="mb-3" controlId="eventLink">
            <Form.Label>Link embed</Form.Label>
            <Form.Control type="text" value={embedLink} onChange={(e) => setEmbedLink(e.target.value)} />
          </Form.Group>
          <Form.Group className="mb-3" controlId="eventFinished">
            <Form.Label>Terminato</Form.Label>
            <div>
              <Form.Check inline label="Sì" type="radio" checked={finished === true} onChange={() => setFinished(true)} />
              <Form.Check inline label="No" type="radio" checked={finished === false} onChange={() => setFinished(false)} />
            </div>
          </Form.Group>
          <Form.Group className="mb-3" controlId="eventStatus">
            <Form.Label>Stato evento</Form.Label>
            <div>
              <Form.Check inline label="Attivo" type="radio" checked={status === "active"} onChange={() => setStatus("active")} />
              <Form.Check inline label="Inattivo" type="radio" checked={status === "inactive"} onChange={() => setStatus("inactive")} />
            </div>
          </Form.Group>
          <Button className="login-submit" size="lg" type="submit" disabled={buttonDisabled}>
            Modifica
          </Button>
        </Form>
      </div>
    </div>
  );
};

export default ModifyEvent;
